<template>
  <div class="interface">
    <!-- 导航栏 -->
    <!-- <div class="navigation">
      <div class="back"><<</div>
      <img :src="logUrlList.home" class="home_img" />
    </div> -->
    <div class="subject">
      <div class="header"></div>
      <div class="main">
        <div class="resImagearr">
          <div class="headerhint">图片已上传，审核中...</div>
          <img
            v-if="displayImage01"
            :src="cardFace"
            alt=""
            class="resImage01"
          />
          <img
            v-if="displayImage02"
            :src="cardFace"
            alt=""
            class="resImage02"
          />
        </div>
        <div class="hintarr">
          <div class="hint01">温馨提示:</div>
          <div class="hint02">{{ hint01 }}</div>
          <div class="hint02">{{ hint02 }}</div>
          <!-- <div class="hint">{{ hint03 }}</div> -->
        </div>
      </div>
      <div class="footer">
        <div class="ok" @click="ok()">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
const logUrl = require("@/common/logUrl.js");
export default {
  name: "orderResult_customs_ningbo",
  data() {
    return {
      logUrlList: logUrl.logUrl,
      hint01: "1. 图片审核时间：24小时以内；",
      hint02: "2. 图片审核期间请不要再次申请",
      // hint03: "否则有可能使得此次申请卡失败",
      cardFace: "",
      cardOri: "", //横竖版
      displayImage01: "",
      displayImage02: "",
    };
  },
  methods: {
    ok() {
      // this.clearUp();
      this.$router.push({
        name: "home_ningbo",
      });
    },
    // clearUp() {
    //   localStorage.removeItem("cardFace");
    //   localStorage.removeItem("cardOri");
    //   this.displayImage = "";
    // },
  },
  created() {
    // this.cardOri = localStorage.getItem("cardOri");
    // // 如果为空
    // if (this.cardOri == null) {
    //   this.displayImage01 = false;
    //   this.displayImage02 = false;
    // }
    // if (this.cardOri == 0) {
    //   //横版
    //   this.displayImage01 = true;
    // } else if (this.cardOri == 1) {
    //   //竖版
    //   this.displayImage02 = true;
    // }
    // this.cardFace = localStorage.getItem("cardFace");
  },
};
</script>

<style scoped>
/* .navigation {
  position: fixed;
  z-index: 1000;
  width: 100%;
  background: linear-gradient(left, #3861d5, white);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 2rem;
}
.home_img {
  width: 1.8rem;
}
.back {
  font-weight: 700;
  color: white;
} */
/* 页面主体内容 */
.subject {
  padding: 1.8rem 1.8rem 0;
  /* background-color: pink; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.headerhint {
  margin-top: 2rem;
}
.resImagearr {
  width: 20rem;
  height: 20rem;
  background: url("../../../../static/demoImage/payres01.png") no-repeat center /
    cover;
  border: black dashed 1px;
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  align-items: center;
  margin: 0 auto;
}
.hintarr {
  padding-top: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  font-size: 1rem;
  font-weight: 500;
}
.hint01 {
  font-weight: 700;
}
/* .header {
  background-color: aqua;
  height: 3rem;
} */
/* .main {
  background-color: yellow;
  height: 3rem;
} */

/* .footer {
  background-color: blue;
  height: 3rem;
} */
.ok {
  width: 80%;
  height: 2.8rem;
  border-radius: 1.4rem;
  /* background-color: #3861d5; */
  background: linear-gradient(to right, #093695, #0d1632);
  color: white;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  margin: 0 auto;
  margin-top: 3rem;
}
.resImage01 {
  margin-top: 3rem;
  width: 60%;
}
.resImage02 {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/components/ningboBus/Customs/OrderResult_ningbo.vue